import { Card, Colors, Heading, Icon, Pills, Text } from '@amelio/ui-library';

import type { TranslationKey } from '@/i18n-key';

import { useAmelioTranslations } from '@/hooks';

export type EvaluationClosedVariant = 'closed' | 'alreadyAnswered' | 'unavailable';

const COPY: Record<
    EvaluationClosedVariant,
    { pill: TranslationKey; title: TranslationKey; description: TranslationKey }
> = {
    closed: {
        pill: 'reviewAnswer.evaluationClosed.pill',
        title: 'reviewAnswer.evaluationClosed.title',
        description: 'reviewAnswer.evaluationClosed.description',
    },
    alreadyAnswered: {
        pill: 'reviewAnswer.alreadyAnswered.pill',
        title: 'reviewAnswer.alreadyAnswered.title',
        description: 'reviewAnswer.alreadyAnswered.description',
    },
    unavailable: {
        pill: 'reviewAnswer.unavailable.pill',
        title: 'reviewAnswer.unavailable.title',
        description: 'reviewAnswer.unavailable.description',
    },
};

interface EvaluationClosedPageProps {
    variant?: EvaluationClosedVariant;
}

const EvaluationClosedPage = ({ variant = 'closed' }: EvaluationClosedPageProps) => {
    const { t } = useAmelioTranslations();
    const copy = COPY[variant];

    return (
        <div
            className={
                'relative flex min-h-screen w-full items-center justify-center overflow-hidden px-6'
            }
        >
            <Card className={'bg-primary-50 relative w-full max-w-lg rounded-2xl p-8 px-8'}>
                <div className={'absolute -top-3 -left-7'}>
                    <Pills
                        variant={'purple'}
                        size={'sm'}
                    >
                        {t(copy.pill)}
                    </Pills>
                </div>

                <div className={'flex items-center gap-6'}>
                    <div
                        className={
                            'bg-primary-50 flex aspect-square h-16 w-16 shrink-0 items-center justify-center rounded-full'
                        }
                    >
                        <Icon
                            name={'security-lock-1'}
                            size={32}
                            color={Colors.PRIMARY}
                            aria-hidden
                        />
                    </div>

                    <div>
                        <Heading level={4}>{t(copy.title)}</Heading>

                        <Text
                            size={'small'}
                            className={'mt-1'}
                            color={Colors.BASE_600}
                        >
                            {t(copy.description)}
                        </Text>
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default EvaluationClosedPage;
